import * as yup from 'yup'
import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'

function generateValidationSchema(t: any) {
  const validationSchema = yup.object().shape({
    clientName: yup
      .string()
      .nullable()
      .trim()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('PurgeTransactions:clientName.label')}`,
        }),
      ),
    accountName: yup
      .string()
      .nullable()
      .trim()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('PurgeTransactions:accountName.label')}`,
        }),
      ),
    checkFile: yup
      .string()
      .nullable()
      .trim()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('PurgeTransactions:dataFileUpload.label')}`,
        }),
      ),
    purgeType: yup.number(),
  })
  return validationSchema
}

export { generateValidationSchema }
